var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.tips),function(tip){return _c('li',{key:tip.id},[_c('InlineTip',{attrs:{"tip":tip}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }